module.exports = __webpack_public_path__ + "static/media/bgimage.f1b12762.jpg";